import { Component, Output, Input, EventEmitter } from '@angular/core';
import { BaseFormComponent } from '../../base-form.component';
import { CommonFunctions } from 'src/app/shared/common/common-functions';

@Component({
  selector: 'app-dropdown-field',
  templateUrl: './dropdown-field.component.html',
  styles: [],
  standalone: false,
})
export class DropdownFieldComponent extends BaseFormComponent {
  @Input() dropdownData: CodeDisplayModel[];
  @Input() regular?: boolean;
  @Input() FIELD_SPACING: number;
  @Input() inputWidth: string = '';
  @Input() LABEL_SPACING: number;
  @Input() label2?: string;
  @Input() TITLE_COLUMNS: string = '9';
  @Input() columns: number = 12;
  
  @Output() userInput? = new EventEmitter<string>();

  constructor(private commonFunctions: CommonFunctions) {
    super(commonFunctions);
  }

  userAction(input) {
    this.userInput.emit(input.target.value);
  }
}

export interface CodeDisplayModel {
  code: string;
  display: string;
  value?: string;
}
